import {
  DnDParentRenderer,
  getParentDnDProps,
} from '@design-system/components/dndList/DndList';
import {
  DndParent,
  DnDItem,
} from '@design-system/components/dndList/DndList.utils';
import { createContext, useContext } from 'react';

import {
  ProgramCardRow,
  ProgramsVM,
} from '../../view-model/programs.viewModel.types';

import { ProgramCard } from './ProgramCard';

export type ProgramCardDndParent = DndParent<DnDItem>;

type ProgramCardRendererContextValue = {
  rowsById: Record<string, ProgramCardRow>;
  dispatch: ProgramsVM['dispatch'];
};

export const ProgramCardRendererContext =
  createContext<ProgramCardRendererContextValue | null>(null);

export const ProgramCardRenderer: DnDParentRenderer<ProgramCardDndParent> = ({
  item,
  provided,
}) => {
  const context = useContext(ProgramCardRendererContext);
  if (!context) return null;

  const row = context.rowsById[item.id];
  if (!row) return null;

  return (
    <ProgramCard
      row={row}
      dispatch={context.dispatch}
      isDnDEnabled
      dndProps={getParentDnDProps(provided)}
    />
  );
};
